import React from 'react';
import { Link } from 'react-router-dom';
import { Event, OpenAccount2 } from './Event';

export class EventList extends React.Component {
//export const EventList = ({ match, days }) => {
    constructor({ days, props }) {
        super(props);
        this.state = {
            paramTitle: "Driver ID",
            date: '',
            type: '',
            param1: '',
            comment: '',
            days: days,
            header: {},
            openAccounts: [],
            floaters: []
        }

        this.handleAttendanceRequest = this.handleAttendanceRequest.bind(this);
        this.addDriverEventRequest = this.addDriverEventRequest.bind(this);
        this.deleteEventRequest = this.deleteEventRequest.bind(this);
        this.postDeleteProcess = this.postDeleteProcess.bind(this);
        this.handleAttendanceRequest(null, '');

    };


    handleAttendanceRequest = (event) => {
        if (event != null) {
            event.preventDefault();
            this.setState({ date: event.target.value });
            this.getWeeklyAttendance(event.target.value);
        }
        else {
            this.getWeeklyAttendance('');
        }
    };

    addDriverEventRequest = (event) => {
        if (event != null) {
            event.preventDefault();
            this.AddDriverEvent(event.target.id, event.target.value)
            return
        }
    };

    deleteEventRequest = (event) => {
        if (event != null) {
            event.preventDefault();
            
            var answer = window.confirm('Are you sure you wish to delete this item?') ? "confirm" : "cancel"
            if (answer === "confirm") {
                this.DeleteEvent(event.target.id)
                    .then(res =>
                        this.postDeleteProcess(res)
                      
                    )              
            }
            return
        }
    };

    postDeleteProcess(res) {
        if (res === 0) {
            this.getWeeklyAttendance(this.state.date);
        }
    }

    render() {
        return (
            <div className="events-list">
                <div class="container">
                    <div class="row">
                        <div class="col-2">
    </div>
                        <div class="col-sm">
                            <form class="form-inline">
                                <div class="form-group mb-2">
                                    <label for="staticEmail2" class="sr-only">Weekly Attendance</label></div>
                                <h3>Weekly Account Coverage</h3>
                                <div class="form-group mx-sm-3 mb-2">
                                    <label for="inputDate" class="sr-only">Date</label>
                                    <input type="Date" class="form-control" id="inputDate" placeholder="Date" onChange={this.handleAttendanceRequest}/>
                                </div>
                            </form>
    </div>
                        <div class="col-2">

    </div>
                    </div>
                </div>
                
                <table class="table ml-2">
                    <thead>
                        <tr>
                            <th>Account</th>
                            <th>{this.state.header.date1} </th>
                            <th>{this.state.header.date2} </th>
                            <th>{this.state.header.date3} </th>
                            <th>{this.state.header.date4} </th>
                            <th>{this.state.header.date5} </th>
                            <th>{this.state.header.date6} </th>
                            <th>{this.state.header.date7} </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.openAccounts.map((oa, i) =>

                                <OpenAccount2
                                    key={i}
                                    {...oa}
                                    floaters={this.state.floaters}
                                    funcDelete={this.deleteEventRequest}
                                    funcAddDriver={this.addDriverEventRequest}
                                />
                            )
                        }
                        <tr>
                            <td>

                            </td>
                            <td>
                                {
                                    this.state.days.filter(event => event.day === "Sunday").map((event, i) =>
                                        <Event
                                            key={i}
                                            {...event}
                                        />
                                    )
                                }
                            </td>
                            <td>
                                {
                                    this.state.days.filter(event => event.day === "Monday").map((event, i) =>
                                        <Event
                                            key={i}
                                            {...event}
                                        />
                                    )
                                }
                            </td>
                            <td>
                                {
                                    this.state.days.filter(event => event.day === "Tuesday").map((event, i) =>
                                        <Event
                                            key={i}
                                            {...event}
                                        />
                                    )
                                }
                            </td>
                            <td>
                                {
                                    this.state.days.filter(event => event.day === "Wednesday").map((event, i) =>
                                        <Event
                                            key={i}
                                            {...event}
                                        />
                                    )
                                }
                            </td>
                            <td>
                                {
                                    this.state.days.filter(event => event.day === "Thursday").map((event, i) =>
                                        <Event
                                            key={i}
                                            {...event}
                                        />
                                    )
                                }
                            </td>
                            <td>
                                {
                                    this.state.days.filter(event => event.day === "Friday").map((event, i) =>
                                        <Event
                                            key={i}
                                            {...event}
                                        />
                                    )
                                }
                            </td>
                            <td>
                                {
                                    this.state.days.filter(event => event.day === "Saturday").map((event, i) =>
                                        <Event
                                            key={i}
                                            {...event}
                                        />
                                    )
                                }
                            </td>
                        </tr>

                    </tbody>
                </table>

            </div>
        )
    }



    async AddDriverEvent(eventNumber, driver) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ParamString1: eventNumber, ParamString2: driver })
        };
        const response = await fetch('utils/saveeventdriver', requestOptions);
        const data = await response.json();
        if (data === "") {
            console.log("blank");
        } else {
            var res = JSON.parse(data)[0]
            if (res.result === 0) {
                return 0;
            }
        }
    }


    async DeleteEvent(eventNumber) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ParamString: eventNumber })
        };
        const response = await fetch('utils/deleteevent', requestOptions);
        const data = await response.json();
        if (data === "") {
            console.log("blank");
        } else {
            var res = JSON.parse(data)[0]
            if (res.result === 0) {
                alert("Deleted");
                return 0;
            }
        }

    }


    async getWeeklyAttendance(targetDate) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ParamString: targetDate })
        };
        const response = await fetch('utils/attendance', requestOptions);
        const data = await response.json();
        if (data === "") {
            console.log("blank");
        } else {
            this.setState({ days: JSON.parse(data[0]) });
        }

        const requestOptions2 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ParamString: targetDate })
        };
        const response2 = await fetch('utils/attendancedates', requestOptions2);
        const data2 = await response2.json();
        if (data2 === "") {
            console.log("blank2");
        } else {
            var d = JSON.parse(data2[0]);
            this.setState({ header: d[0] });
        }

        const requestOptions3 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ParamString: targetDate })
        };
        const response3 = await fetch('utils/openaccounts', requestOptions3);
        const data3 = await response3.json();
        if (data3 === "" || data3[0] === "") {
            this.setState({ openAccounts: [] });
        } else {
            this.setState({ openAccounts: JSON.parse(data3[0]) });
        }


        const response4 = await fetch('utils/floaters');
        const data4 = await response4.json();
        if (data4 === "") {
            console.log("blank4");
        } else {
            this.setState({ floaters: JSON.parse(data4) });
            
        }

    }

}